import { Tooltip, TooltipTrigger } from '@design/components/tooltip/Tooltip';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './InsightDrawerHeader.module.scss';
import type { InsightDrawerHeaderProps } from './insightDrawerHeaderTypes';

export const InsightDrawerHeader = (props: InsightDrawerHeaderProps) => {
  const { t } = useTranslation(['widget']);

  const isInteractive = props.variant !== 'static';
  const overviewLabel =
    props.variant === 'theme'
      ? t('widget:assetOverview.openThemeOverview')
      : t('widget:assetOverview.openAssetOverview');

  return (
    <div
      className={clsx(styles.root, {
        [styles.interactive]: isInteractive,
      })}
    >
      {isInteractive && (
        <Tooltip
          inPortal
          isTouchDevice={false}
          label={overviewLabel}
          trigger={[TooltipTrigger.Hover, TooltipTrigger.Focus]}
        >
          <button
            aria-label={overviewLabel}
            className={styles.overviewButton}
            onClick={props.onOpenOverview}
            type="button"
          />
        </Tooltip>
      )}

      <div className={styles.identity}>
        <div className={styles.logo}>{props.logo}</div>
        <div className={styles.details}>
          <div className={styles.nameRow}>
            <span className={styles.name}>{props.name}</span>
            {isInteractive && (
              <div className={styles.action}>{props.action}</div>
            )}
          </div>
          {isInteractive && props.performance && (
            <div className={styles.performance}>{props.performance}</div>
          )}
        </div>
      </div>
    </div>
  );
};
